import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TrainingPresenter, getSlides } from '../features/training';
import { trackEvent } from '../shared';

/**
 * AITrainingPage - AI in white-collar jobs training
 */
function AITrainingPage() {
  const { i18n } = useTranslation();
  const slides = getSlides('aiLiteracy', i18n.language);

  useEffect(() => {
    trackEvent('training_started', {
      module: 'aiLiteracy',
      language: i18n.language,
      slideCount: slides.length,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <TrainingPresenter slides={slides} moduleName="aiLiteracy" />;
}

export default AITrainingPage;
